import "stylesheets/components/common/Pagination.css";
import ReactPaginate from "react-paginate";
import React from "react";

// This is just a wrapper component so that the css is automatically included.
export default (props) => <ReactPaginate {...props} />;